const apiOrigin = import.meta.env.VITE_API_ORIGIN ?? '';

interface ErrorBody {
  message?: string;
  pointer?: string;
}

export async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body !== undefined && options.body !== null && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const response = await fetch(`${apiOrigin}${path}`, {
    ...options,
    credentials: 'include',
    headers,
  });
  const body = await response.json() as ErrorBody;
  if (!response.ok) {
    const pointer = body.pointer === undefined ? '' : ` (${body.pointer})`;
    throw new Error(`${body.message ?? 'The platform request failed.'}${pointer}`);
  }
  return body as T;
}

export function readError(error: unknown): string {
  return error instanceof Error ? error.message : 'The platform request failed.';
}
